var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCexLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 155,
    viewBox: "0 0 116 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999589 53.7962C3.42655 23.3833 29.6234 -1.34568 59.3179 0.0568597C88.2273 0.204495 114.567 26.1884 114.067 56.2322C106.001 61.5471 96.9358 65.9762 88.6556 70.922C93.3667 56.4537 88.5128 39.4756 76.4494 31.208C68.1692 25.2287 57.1051 23.2357 47.4687 26.7789C32.4786 32.0938 21.8429 49.5886 26.2685 66.05C26.4826 68.0431 27.2678 70.0362 27.6247 71.9554C19.1304 67.8954 9.70808 61.9162 0.856826 57.1919C0.642683 56.0108 1.07097 54.9035 0.999589 53.7962Z",
    fill: "#002237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7594 55.7891C41.1157 46.3404 49.2531 39.5492 58.3899 40.1397C69.3112 40.8041 77.8055 51.8768 75.3786 63.0233C73.4513 72.9149 63.1724 79.1894 53.6787 77.6392C44.0423 75.7938 38.0463 65.6069 39.7594 55.7891Z",
    fill: "#002237"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 61.7683L49.1816 89.6715C40.83 94.7649 32.2643 100.227 23.413 103.918C10.3503 93.8053 1.92729 78.525 0 61.7683Z",
    fill: "#004570"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.500199 153.524C3.28406 131.452 18.8451 112.924 37.6184 105.247L46.541 100.301L115.067 61.6943C112.426 83.323 98.9347 101.851 79.5905 110.488L71.0961 115.212L9.13731 150.276C6.06793 151.678 3.21268 153.967 0.214676 155C0.571581 154.483 0.357436 153.967 0.500199 153.524Z",
    fill: "#004570"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0985 126.802L90.5109 113.146C104.716 121.856 111.854 138.244 115.566 154.484C113.781 154.189 112.068 153.377 110.355 152.712L66.3841 127.688C66.2413 127.393 65.4561 127.171 66.0985 126.802Z",
    fill: "#004570"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCexLogoSm);
export default __webpack_public_path__ + "static/media/cex-logo-sm.8731351c395b06451dad76d97f436dbd.svg";
export { ForwardRef as ReactComponent };